import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { EncryptionService } from '../services/encryption.service';

// Routes dont le body doit être chiffré — uniquement auth partenaire
const ENCRYPTED_ROUTES = [
  '/api/auth-ptr/Login',
  '/api/auth-ptr/CompleteRegistration',
  '/api/auth-ptr/ResetPassword',
  '/api/auth-ptr/ChangePassword',
];

@Injectable()
export class EncryptionInterceptor implements HttpInterceptor {
  constructor(private encryptionService: EncryptionService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldEncrypt =
      request.method === 'POST' &&
      ENCRYPTED_ROUTES.some((route) => request.url.includes(route)) &&
      request.body !== null;

    if (!shouldEncrypt) {
      return next.handle(request);
    }

    return from(this.encryptionService.encryptPayload(request.body)).pipe(
      switchMap((envelope) => {
        const encryptedRequest = request.clone({
          body: envelope,
          setHeaders: { 'X-Encrypted': '1' },
        });
        return next.handle(encryptedRequest);
      })
    );
  }
}
